import React, { useRef, useState } from "react";
import SectionHeader from "./SectionHeader";
import treeImg from "../../assets/treeoverlay.png";
import { IconButton, Typography } from "@mui/material";
import { East, West } from "@mui/icons-material";
import { testimonialsData } from "../../api/HomeApi";
import Slider from "react-slick";
import { Box } from "@mui/system";

const style = {
  mainContainer: {
    // padding: { xs: "50px 0", sm: "20px 0px" },
    paddingTop: {
      xl: "70px",
      md: "70px",
      sm: "50px",
      xs: "50px",
    },
    boxSizing: "border-box",
    width: "100%",
  },
  imgOverlayWrapper: {
    backgroundColor: "#ffff",
    position: "relative",
    width: "100%",
    display: "flex",
    justifyContent: "space-between",
    zIndex: 1,
  },
  overlayWrapper: {},
  buttonOverlay: {
    position: "absolute",
    top: { xs: "50%", sm: "40%" },
    width: "100%",
    gap: "20px",
    display: "flex",
    justifyContent: "space-between",
    zIndex: 4,
  },
  bgGate: {
    width: { xs: "177px", sm: "398px" },
    height: { xs: "200px", sm: "450px" },
    borderRadius: "219px 219px 0px 0px",
    backgroundColor: "#F7EEE680",
    position: "absolute",
    bottom: 0,
    zIndex: 2,
    left: "50%",
    transform: "translateX(-50%)",
  },
  controlBtn: {
    btn: {
      width: { xs: "40px", sm: "50px" },
      height: { xs: "40px", sm: "50px" },
      border: "1px solid #E1D9CF",
      color: "#E1D9CF",
      borderRadius: 0,
    },
    left: {
      position: "absolute",
      left: { xs: "10%", sm: "20%" },
      top: { xs: "20px", sm: "unset" },
    },
    right: {
      position: "absolute",
      right: { xs: "10%", sm: "20%" },
      top: { xs: "20px", sm: "unset" },
    },
  },
  SliderWrapper: {
    width: { xs: "274px", sm: "320px", md: "440px", lg: "681px" },
    zIndex: 6,
    justifySelf: "center",
    position: "absolute",
    // marginTop: "25%",
    height: "450px",
    left: "50%",
    transform: { xs: "translate(-50%, -40%)", sm: "translate(-50%, -80%)" },
  },
  testimonialText: {
    title: {
      fontFamily: "ZapfHumnst BT",
      fontWeight: "600",
      textAlign: "center",
      fontSize: { xs: "16px", sm: "20px", md: "24px", lg: "32px" },
      letterSpacing: "5%",
      color: "#B8772A",
      fontStyle: "italic",
      lineHeight: {
        xs: "17.64px",
        sm: "30.24px",
      },
      marginBottom: { xs: 1, sm: 2 },
    },
    description: {
      fontFamily: "sora",
      fontWeight: "200",
      letterSpacing: "1%",
      fontSize: { xs: "12px", sm: "18px", md: "24px", lg: "28px" }, // Updated
      lineHeight: { xs: "20px", sm: "30px", md: "36px", lg: "42px" },
      color: "#4C4C4C",
      textAlign: "center",
    },
    personName: {
      fontFamily: "sora",
      fontWeight: "600",
      textAlign: "center",
      letterSpacing: "5%",
      color: "#4C4C4C",
      fontSize: {
        xs: "14px",
        sm: "24px",
      },
      lineHeight: {
        xs: "17.64px",
        sm: "30.24px",
      },
    },
    personRole: {
      fontFamily: "sora",
      fontWeight: "300",
      textAlign: "center",
      letterSpacing: "3%",
      color: "#181818",
      fontSize: {
        xs: "12px",
        sm: "16px",
      },
      lineHeight: {
        xs: "15.12px",
        sm: "20.16px",
      },
    },
  },
  imgstyle: {
    width: { xs: "67px", sm: "164px" },
    height: { xs: "201px", sm: "492px" },
  },
};

const Testimonial = () => {
  const sliderRef = useRef(null);
  const [, setCurrentSlide] = useState(0);

  const settings = {
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplaySpeed: 2000,
    easing: "ease-in-out",
    autoplay: true,
    swipeToSlide: true,
    draggable: true,
    beforeChange: (current, next) => setCurrentSlide(next),
  };

  const handlePrev = () => {
    if (sliderRef.current) {
      sliderRef.current.slickPrev();
    }
  };

  const handleNext = () => {
    if (sliderRef.current) {
      sliderRef.current.slickNext();
    }
  };

  return (
    <Box sx={style.mainContainer}>
      <SectionHeader
        title={"TESTIMONIALS"}
        description={"Memorable Stays, Cherished Words"}
      />
      <Box>
        <Box
          sx={{
            position: "relative",
            width: "100%",
            marginTop: { xs: 5, sm: 1 },
          }}
        >
          <Box sx={style.imgOverlayWrapper}>
            <Box sx={style.imgstyle}>
              <img src={treeImg} alt="" width={"100%"} />
            </Box>
            <Box sx={style.imgstyle}>
              <img
                src={treeImg}
                width={"100%"}
                style={{ transform: "scaleX(-1)" }}
                alt=""
              />
            </Box>
          </Box>
          <Box sx={style.buttonOverlay}>
            <IconButton
              disableRipple
              sx={{
                ...style.controlBtn.btn,
                ...style.controlBtn.left,
                display: "flex",
                justContent: "center",
                alignItems: "center",

                cursor: "pointer",
                background: "transparent",
                position: "relative",
                overflow: "hidden",
                zIndex: 1,
                transition: "ease 0.1s",
                "&::before": {
                  content: '""',
                  position: "absolute",
                  height: "100%",
                  width: "0%",
                  top: 0,
                  right: "-40px",
                  backgroundColor: "#E4CAAE",
                  zIndex: -1,
                  transition: "all 1s",
                },
                "&:hover": {
                  color: "#A88765",
                },
                "&:hover::before": {
                  width: "200%",
                },
              }}
              onClick={handlePrev}
            >
              <West />
            </IconButton>
            <IconButton
              disableRipple
              sx={{
                ...style.controlBtn.btn,
                ...style.controlBtn.right,
                display: "flex",
                justContent: "center",
                alignItems: "center",

                cursor: "pointer",
                background: "transparent",
                position: "relative",
                overflow: "hidden",
                zIndex: 1,
                transition: "ease 0.1s",
                "&::before": {
                  content: '""',
                  position: "absolute",
                  height: "100%",
                  width: "0%",
                  top: 0,
                  left: "-40px",
                  backgroundColor: "#E4CAAE",
                  zIndex: -1,
                  transition: "all 1s",
                },
                "&:hover": {
                  color: "#A88765",
                },
                "&:hover::before": {
                  width: "200%",
                },
              }}
              onClick={handleNext}
            >
              <East />
            </IconButton>
          </Box>
          <Box sx={style.bgGate} />
        </Box>
        <Box sx={style.SliderWrapper}>
          <Slider {...settings} ref={sliderRef}>
            {testimonialsData.map((testimonial, index) => (
              <Box
                sx={{
                  width: "100%",
                  height: "100%",
                }}
                key={index}
              >
                <Typography sx={style.testimonialText.title}>
                  {testimonial.title}
                </Typography>
                <Typography sx={style.testimonialText.description}>
                  {testimonial.description}
                </Typography>
                <Box
                  display={"flex"}
                  flexDirection={"column"}
                  sx={{ marginTop: { xs: 5, sm: 10 } }}
                >
                  <Typography sx={style.testimonialText.personName}>
                    {testimonial.name}
                  </Typography>
                  <Typography sx={style.testimonialText.personRole}>
                    {testimonial.role}
                  </Typography>
                </Box>
              </Box>
            ))}
          </Slider>
        </Box>
      </Box>
    </Box>
  );
};

export default Testimonial;
